export default __webpack_public_path__ + "static/media/sample_10.36254671.png";